// extracted by mini-css-extract-plugin
export default {"root":"root___lCUmL","header":"header___Gr_w0","header_text":"header_text___ECs9C","header_image":"header_image___o2_Bn"};